import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17 4v11h11v2H17v11h-2V17H4v-2h11V4h2Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcPlus;
